export default __webpack_public_path__ + "static/media/vehicle-5.e42850af.png";